import api from "./core";

export default {
  async getClient($id) {
    return api.get(`api/kiosk/Patients/${$id}`);
  },
  async getMedicationRoutes() {
    return api.post(`api/kiosk/MedicationRoute`, {});
  },
  async getMeasurements() {
    return api.post(`api/kiosk/UnitOfMeasurement`, {});
  },
  async getDiagnosisCodeStatuses() {
    return api.post(`api/kiosk/DiagnosisCodeStatus`, {});
  }
};
